import { isDev, Environment } from './env';

const productionUrls = ['www.lucidchart.com', 'lucidspark.com', 'lucid.co', 'lucidforeducation.com'];
const preProductionUrls = ['www.preprodchart.com', 'preprodspark.lucidmarketingtest.com', 'preprodgo.com'];
const lucidAppUrl = 'lucid.app';
const lucidPreProdAppUrl = 'lucidpreprod.app';
const lucidDevUrl = 'luciddev.app';
const lucidStagingUrl = 'lucidstaging.app';
const lucidchartDevUrl = 'dev.lucidchart.ninja';
const lucidsparkDevUrl = 'devspark.lucidmarketingtest.com';
const lucidchartStagingUrl = 'lucidchart.ninja';
const lucidsparkStagingUrl = 'stagingspark.lucidmarketingtest.com';
const lucidchartOfficeUrl = 'office.lucidchart.com';
const localhostUrl = 'localhost';

const productDomain = (hostname: string, port?: string): string => {
  if (productionUrls.includes(hostname)) {
    return lucidAppUrl;
  }

  if (preProductionUrls.includes(hostname)) {
    return lucidPreProdAppUrl;
  }

  if (hostname.endsWith(lucidchartDevUrl)) {
    return hostname.replace(lucidchartDevUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidsparkDevUrl)) {
    return hostname.replace(lucidsparkDevUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidchartOfficeUrl)) {
    return hostname.replace(lucidchartOfficeUrl, lucidDevUrl);
  }

  if (hostname.endsWith(lucidsparkStagingUrl)) {
    return hostname.replace(lucidsparkStagingUrl, lucidStagingUrl);
  }

  if (hostname === `${localhostUrl}${port ? `:${port}` : ''}`) {
    return hostname.replace(localhostUrl, isDev() ? `${localhostUrl}${port ? `:${port}` : ''}` : '');
  }

  return hostname.replace(lucidchartStagingUrl, lucidStagingUrl);
};

export const productDomainEnv = (hostname: string, port?: string): Environment => {
  const domain = productDomain(hostname, port);

  if (domain.includes(lucidAppUrl)) {
    return 'production';
  }

  if (domain.includes(lucidPreProdAppUrl)) {
    return 'preprod';
  }

  if (domain.includes(lucidDevUrl)) {
    return 'staging';
  }

  if (domain.includes(localhostUrl)) {
    return 'development';
  }

  return 'staging';
};

export default productDomain;
